import { useState, useEffect } from "react";
import {
  Button,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { GridColDef, GridRowParams, MuiEvent } from '@mui/x-data-grid';
import { createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppDispatch } from "../../hooks";
import { ISprayRecord } from "../../interfaces/Growing/ISprayRecord";
import moment from "moment";
import SprayRecordDialog from "./SprayRecordDialog";
import ActionButton from "../../components/ActionButton";
import ActionMenu from "../../components/ActionMenu";

type Anchor = 'top' | 'left' | 'bottom' | 'right';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[300],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));


interface IFormInput {
  Name: string
  Type: string
  Crew: string
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}


export default function SprayRecords() {

  function ButtonClicked(_event: React.MouseEvent<HTMLElement>): void {
      
    setOpen(true);
  }

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(!open);
  }

  const buttons = [
    <ActionButton action={ButtonClicked} buttonLabel="DOWNLOAD REPORT" />,
   
  ];

  const dispatch = useAppDispatch();
  const [sprayOpen, setSprayOpen] = useState(false);
  const [selectedSprayId, setSelectedSprayId] = useState(0);
  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Spray Records",
      backgroundPath: "/assets/images/growing.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [rows, setRows] = useState<ISprayRecord[]>([]);

  useEffect(() => {
    axios
      .get('https://localhost:44324/api/SprayRecords')
      .then(res => {
        setRows(res.data);
        console.log(res.data);
      })
  }, [sprayOpen]);

 const [helpOpen, setHelpOpen] = React.useState(false);

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };


  const columnsprayrecords: GridColDef[] = [
   // { field: 'id', headerName: 'ID', width: 200},
    { field: 'item', headerName: 'Item', width: 200, valueGetter: (params) => {return params.row.chemical.name}  },
    { field: 'chemical.epaNumber', headerName: 'EPA Reg #', width: 180, valueGetter: (params) => {return params.row.chemical.epaNumber} },
    { field: 'chemical.activeIngrediant', headerName: 'Active Ingredient', width: 270, valueGetter: (params) => {return params.row.chemical.activeIngrediant} },
    { field: 'location', headerName: 'Location', width: 200, valueGetter: (params) => {return params.row.bay != null ? params.row.bay.name : ""} },
    { field: 'gallonsApplied', headerName: 'Gallons Applied', width: 120, },
    { field: 'rate', headerName: 'Rate', width: 170, },
    { field: 'chemical.rei', headerName: 'REI', width: 200, valueGetter: (params) => {return params.row.chemical != null ? params.row.chemical.rei : ""}  },
    { field: 'appliedAt', headerName: 'Applied Date', width: 250, valueGetter: (params) => { let date = moment(params.row.appliedAt); return date.format("MMMM Do YYYY, h:mm:ss A");} },
    { field: 'reentrydate', headerName: 'Rentry Date', width: 250, valueGetter: (params) => { let date = moment(params.row.reentryAt); return date.format("MMMM Do YYYY, h:mm:ss A");}  },
    { field: 'grower', headerName: 'Grower', width: 200, valueGetter: (params) => {return params.row.grower != null ? params.row.grower.userName : ""}  },
    { field: 'handler', headerName: 'Handler', width: 200, valueGetter: (params) => {return params.row.handler != null ? params.row.handler.userName : ""}  },
  ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  const onDownload = () => {
    const link = document.createElement("a");
    link.download = `download.txt`;
    link.href = "./download.txt";
    link.click();
  };

  const handleSprayOpen = () => {
    setSprayOpen(true);
  };

  const handleSprayClose = () => {
    setSelectedSprayId(0);
    setSprayOpen(false);
  };

  const handleDoubleClick = (x: GridRowParams<any>, y: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>) => {
    setSelectedSprayId(x.row.id);
    setSprayOpen(true);
  }

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });


  return (

    <div>
   <ActionMenu buttons={buttons} />
      <Grid container spacing={0} bgcolor="#101010" >
        <Grid item xs={12}>
          <Item>
            <div style={{ height: 'calc(100vh - 75px)', width: '100%' }}>
              <StripedDataGrid
                rows={rows}
                columns={columnsprayrecords}
                pageSize={20}
                rowsPerPageOptions={[20]}
                sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                onRowDoubleClick={(x, y) => handleDoubleClick(x, y)}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
              />
            </div>
          </Item>
        </Grid>
      </Grid>

      <SprayRecordDialog isOpen={sprayOpen} handleClose={handleSprayClose} sprayRecordId={selectedSprayId}></SprayRecordDialog>

      <div>
          <BootstrapDialog
            onClose={handleHelpClose}
            aria-labelledby="customized-dialog-title"
            open={helpOpen}
          >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
              Need Support?
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
                If you are having issues or have questions, please contact us below.
              </Typography>
              <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
              </Button>
              <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                <Link href="mailto:bobsmarket@idatp.com" underline="none">
                  <Typography variant='h6' fontWeight={700} color="#FFF">support@idatp.com</Typography></Link>
              </Button>
            </DialogContent>
          </BootstrapDialog>
        </div>

    </div>
  );
}